/**
 * Created by superman on 17/2/16.
 * http配置
 */
import axios from 'axios'
import store from './store/store'
import router from './router'
import { Loading } from 'element-ui';
import {hideLoading, showLoading} from "./loading";

// axios 配置
axios.defaults.timeout = 1000 * 30 * 10
axios.defaults.baseURL = '/swsApi'

var loadinginstace
let debouncedMaskerClose

// http request 拦截器
axios.interceptors.request.use(config => {
    var msg = "Loading..."
    var flg1 = config.url.startsWith("selectMenuList")
    var flg2 = config.url.startsWith("combox/")
    var flg3 = config.url.startsWith("logout")
    var flg4 = config.url.startsWith("doLogin")
    if (flg4) {
      msg = "Logining..."
    }
    var loadFlg = true
    if (flg1 || flg2 || flg3) {
      loadFlg = false
    }
    if (loadFlg) {
      showLoading(msg)
    }
    config.headers.common['Authorization']= `${store.state.token}`
    return config
  },
  error => {
    hideLoading()
    if (error.request) {
    }
    //return Promise.reject(error);
    return null;
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    var flg1 = response.config.url.startsWith("selectMenuList")
    var flg2 = response.config.url.startsWith("combox/")
    var flg3 = response.config.url.startsWith("logout")
    if (flg1 || flg2 || flg3) {
    } else {
      hideLoading()
    }
    let result = response.data

    if (result.retCode == 100 || response.config.responseType == 'arraybuffer' || response.config.responseType == 'blob') {
      return response
    } else if (result.retCode == 404) {
      window.onbeforeunload = function () {
      }
      // window.onunload removed — Chrome Permissions Policy restriction

      store.dispatch('logout')
      router.push({ name: 'error-404' })
      return null
    } else {
      window.onbeforeunload = function () {
      }
      // window.onunload removed — Chrome Permissions Policy restriction

      store.dispatch('logout')
      router.push({ name: 'error-500' })
      return null
    }
  },
  error => {
    hideLoading()
    if (error.response) {
      window.onbeforeunload = function () {
      }
      // window.onunload removed — Chrome Permissions Policy restriction

      store.dispatch('logout')
      router.push({name: 'error-500'})
      //if (error.response.status > 400 && error.response.status <= 500) {
      //  router.push({name: 'error-404'})
      //} else if (error.response.status >= 500 && error.response.status <= 600) {
      //  router.push({name: 'error-500'})
      //} else {
      //  router.push({name: 'error-500'})
      //}
    }
    //return Promise.reject(error.response.data)
    return null
  }
);

export default axios
